import React, { useState } from "react";
import Playstore from "../../assets/playstore.webp";
import { Link } from "gatsby";

const Header = () => {
  const [show, setShow] = useState(false);
  return (
    <header className="header flex justify-between items-center px-[20px] md:px-[40px] py-[10px] sticky top-0 md:relative z-[1000]">
      <img src={Playstore} alt="" className="w-[3rem] h-[3rem]" />
      <ul
        className={`
      flex 
      flex-col 
      md:flex-row 
      gap-[30px] 
      xl:mr-[200px] 
      text-[18px] 
      bg-white 
      md:bg-transparent 
      fixed 
      md:relative
      ${show ? 'top-[62px]' : 'top-[-150%]'}
      md:top-0 
      left-0
      w-[100vw]
      h-[100vh]
      md:w-auto
      md:h-auto
      p-[20px]
      md:p-0
      transition-all
      `}
      >
        <li>
          <Link to="/">Android</Link>
        </li>
        <li>
          <Link to="/">Inversiones</Link>
        </li>
        <li>
          <Link to="/">Lifestyle</Link>
        </li>
        <li>
          <Link to="/">Startups</Link>
        </li>
        <li>
          <Link to="/">Stock Market</Link>
        </li>
      </ul>
      <div
        className={`burger-menu ${show ? "change" : ""} flex md:hidden`}
        onClick={() => setShow(!show)}
      >
        <div className="bar"></div>
        <div className="bar"></div>
        <div className="bar"></div>
      </div>
    </header>
  );
};

export default Header;
